import CentralElementLayout from "common/layouts/CentralElementLayout/CentralElementLayout";
import LoginForm from "modules/user/components/LoginForm/LoginForm";
import CheckMarkSuccess from "common/components/AnimatedIcons/CheckMarkSuccess/CheckMarkSuccess";
import ErrorMark from "common/components/AnimatedIcons/ErrorMark/ErrorMark";
import ProtectedRoute from "common/routes/PrivateRoute/PrivateRoute";
import SideMenuTopBarLayout from "common/layouts/SideMenuTopBarLayout/SideMenuTopBarLayout";
import LogoutForm from "modules/user/components/LogoutForm/LogoutForm";
import { Navigate } from "react-router-dom";
import AccessForm from "modules/user/components/AccessForm/AccessForm";
import ForgotForm from "modules/user/components/ForgotForm/ForgotForm";
import SignUpForm from "modules/user/components/SignUpForm/SignUpForm";
/* 
    NOTA:
    En Element debe ir el Layout y el Layout debe tener como props.children la el view que
    se va usar? 
*/


const DefaultRoutes = [
  
    
    {
      path: "/user/login",
      element: (
        <CentralElementLayout classes={["user-login-page"]}> 
            <LoginForm />
        </CentralElementLayout>
      ),
    },
    {
        path: "/user/logout",
        element: (
          <CentralElementLayout classes={["user-logout-page"]} redirectAfterTo="/user/login" timeOutToRedirect={3000}> 
            <LogoutForm />
          </CentralElementLayout>
        ),
    }
    ,
    {
        path: "/user/restricted",
        element: (
          <CentralElementLayout classes={["user-restricted-page"]} redirectAfterTo="/dashboard" timeOutToRedirect={3000}> 
          <ErrorMark />
             <div style={{textAlign:"center"}}>Error, al acceder.</div>
          </CentralElementLayout>
        ),
    },
    {
        path: "/user/forgot",
        element: (
          <CentralElementLayout classes={["user-forgot-page"]}> 
            <ForgotForm />
          </CentralElementLayout>
        ),
    },
    {
      path: "/user/access/:accessTok",
      element: (
        <CentralElementLayout classes={["user-access-page"]}> 
          <AccessForm />
        </CentralElementLayout>
      ),
  },
    {
      path: "/user/sign-up",
      element:(
        <CentralElementLayout classes={['user-sign-up-page']}>
          <SignUpForm />
        </CentralElementLayout>
      )
    },
    {
        path:"*",
        element:<Navigate to="/dashboard" replace />
    }
];

export default DefaultRoutes;